/*export default {
  install(Vue) {   
Vue.directive('money-prefix', {
  inserted(el) {
    const input = el.querySelector('input')
    if (!input) return

    input.style.textIndent = '8px'

    input.style.backgroundImage = "url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"10\" height=\"16\"><text x=\"0\" y=\"14\" font-size=\"14\" fill=\"%23555\">$</text></svg>')"
    input.style.backgroundRepeat = 'no-repeat'
    input.style.backgroundPosition = '0px center'
    input.style.backgroundOrigin = 'content-box'

    input.style.caretColor = 'auto'
    input.style.paddingTop = "2px"
  }
})
 
  }
};*/

export default {
  install(Vue) {
    Vue.directive('money-prefix', {
      inserted(el) {
        const input = el.querySelector('input')
        if (!input) return

        input.style.textIndent = '8px'

        input.style.backgroundImage =
          "url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"10\" height=\"16\"><text x=\"-1\" y=\"12.5\" font-size=\"14\" fill=\"%23555\">$</text></svg>')"

        input.style.backgroundRepeat = 'no-repeat'
        input.style.backgroundPosition = '1px center'
        input.style.backgroundOrigin = 'content-box'

        input.style.caretColor = 'auto'
      }
    })
  }
}